var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "dashboard-container"
  }, [_c('b-tabs', {
    model: {
      value: _vm.activeTab,
      callback: function callback($$v) {
        _vm.activeTab = $$v;
      },
      expression: "activeTab"
    }
  }, [_c('b-tab', {
    attrs: {
      "title": _vm.$t('dashboard.tab.event')
    }
  }, [_vm.activeTab === 0 ? _c('events') : _vm._e()], 1), _c('b-tab', {
    attrs: {
      "title": _vm.$t('dashboard.tab.sheet')
    }
  }, [_vm.activeTab === 1 ? _c('sheets') : _vm._e()], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }